import { LineGraph } from '../../../../components/Graphs';
import { PIPELINE_THROUGHPUT_GRAPH_QUERY } from './operations';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useQuery } from '@apollo/client';

const useStyles = makeStyles(() => ({
  graph: {
    backgroundColor: 'white',
    margin: '5px',
    padding: '5px',
  },
}));

export default ({ pipelineSegmentId }) => {
  const classes = useStyles();

  const { loading, data } = useQuery(PIPELINE_THROUGHPUT_GRAPH_QUERY, {
    variables: {
      id: pipelineSegmentId,
    },
  });

  return (
    <>
      {!loading && data.graphPipelineThroughputs.throughputs.length > 0 ? (
        <div className={classes.graph}>
          <LineGraph
            key={`pdp-graph-${pipelineSegmentId}`}
            csv={data.graphPipelineThroughputs.throughputs}
            labels={data.graphPipelineThroughputs.labels}
            title="Pipeline Throughput"
            ylabel={data.graphPipelineThroughputs.ylabel}
            stackedGraph={true}
          />
        </div>
      ) : null}
    </>
  );
};
